export default {

    data: function() {

        return {
            items: [],
            list: '',
            lang: ''
        }

    },

    computed: {

        text: function() {

            return {
                noun: this.page[this.lang + '_list_noun'],
                empty: this.page[this.lang + '_list_empty'],
                create: this.page[this.lang + '_list_button_create'],
                edit: this.page[this.lang + '_list_button_edit'],
                delete: this.page[this.lang + '_list_button_delete']
            }

        }

    },

    methods: {

        onCreate: function() {

            this.$pubsub.$emit('modal.open', {
                name: this.list + '/create',
                events: [this.list + '/refresh']
            })

        },

        onEdit: function(id) {

            this.$pubsub.$emit('modal.open', {
                preload: id,
                name: this.list + '/edit',
                events: [this.list + '/refresh']
            })

        },

        onDelete: function(id) {

            this.$pubsub.$emit('modal.open', {
                id: id,
                name: this.list + '/delete',
                events: [this.list + '/refresh']
            })

        },

        onUp: function(id) {

            this.$api.request(this.list + '/up', {
                id: id
            }).then(function() {

                this.$pubsub.$emit(this.list + '/refresh')

            }.bind(this))

        },

        onDown: function(id) {

            this.$api.request(this.list + '/down', {
                id: id
            }).then(function() {

                this.$pubsub.$emit(this.list + '/refresh')

            }.bind(this))

        }

    }

}